<template>
  <div>
    <!--This div is used to announce the title changes during CSR. Refer: page-title.ts for more details -->
    <div id="page-title" aria-live="polite" class="sr-only"></div>
    <LazyTopBannersContainer :hdr-height="52" :is-header-scrollable="true" />
    <div class="app-container">
      <div ref="mainAppDiv" class="main-app position-absolute w-100">
        <Header v-if="route.path.startsWith('/desktop-login')" />
        <NuxtPage />
        <LazyFooter
          v-if="!route.path.startsWith('/child-registration')"
          footer-layout="green"
        />
        <div id="hidden_gigya_div" class="d-none" aria-hidden="true" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { LazyTopBannersContainer } from '#components';

const { calcCookiesBannerState, getCookiesBannerState } = useCookieBanner();
const route = useRoute();
const mainAppDiv = ref(null);

calcCookiesBannerState();

// Adding watchEffect since dynamic classes do not work for SSR
// It is recommended to keep CSR and SSR view similar
watchEffect(() => {
  if (
    getCookiesBannerState() &&
    !route.path.startsWith('/child-registration')
  ) {
    mainAppDiv.value?.classList.add('show-cookies-banner');
  } else {
    mainAppDiv.value?.classList.remove('show-cookies-banner');
  }
});
</script>

<style lang="scss" scoped>
.main-app {
  min-height: 100vh;
}
</style>
